export const versionSort = (numCount, a, b, order) => {
  if ((a.length === 0) && (b.length === 0)) {
    return 0;
  } else if (a.length === 0) {
    return (order === 'asc') ? 1 : -1;
  } else if (b.length === 0) {
    return (order === 'asc') ? -1 : 1;
  }
  const ap = a.split('.', numCount);
  const bp = b.split('.', numCount);
  for (let i = 0; i < numCount; ++i) {
    let diff = parseInt(bp[i], 10) - parseInt(ap[i], 10);
    if (diff === 0) {
      continue;
    }
    return (order === 'asc') ? diff : -diff;
  }
  return 0;
};



// WEBPACK FOOTER //
// ./src/common/arraySort.js